<template>
    <div>
        <!-- Main Bg Gradient -->
        <div class="w-screen h-dvh max-w-full max-h-full landing flex flex-col justify-center items-center">
            <CoachingModeMarble class="h-[60px] w-[60px]" is-loading />
            <!-- Content -->
            <div class="flex flex-col justify-start items-center gap-10 w-full md:w-[600px] text-center pt-4 px-10">
                <div class="flex flex-col gap-5 justify-center items-center pt-4">
                    <div class="text-[#262626] flex md:flex-row flex-col">
                        <!-- Title -->
                        <span class="display-serif">Switching to an Anonymous Space</span>
                    </div>

                    <div class="body-small text-[#262626] text-center w-full">This conversation will not be attached to your Nadia account.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import CoachingModeMarble from "~vue/components/navigation/CoachingModeMarble.vue";
import { onMounted } from "vue";

const emit = defineEmits(["switchingComplete"]);
onMounted(() => {
    setTimeout(() => {
        // Emit the event after a delay to simulate the switching process
        emit("switchingComplete");
    }, 3500); // Adjust the delay as needed
});
</script>

<style scoped>
.landing {
    background-color: rgba(234, 184, 150, 0.6);
    background-image: linear-gradient(150deg, transparent 50%, rgba(234, 184, 150, 1) 90%), linear-gradient(230deg, transparent 65%, rgba(200, 158, 247, 1));
}
</style>
